import './Services.css';
import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPinned } from 'lucide-react';
import Testimonials from '../components/Testimonials';
import {
  Section,
  SectionTitle,
  SectionSubtitle,
  ServicesGrid,
  ServiceCard,
  ServiceIcon,
  ServiceTitle,
  ServiceDescription,
  Footer,
  FooterContent,
  FooterColumn,
  Copyright
} from '../styles';

export default function ServicesPage() {
  return (
    <main style={{ paddingTop: '110px' }}>
      <Section services id="services">
              <SectionTitle initial={{opacity:0,y:30}} whileInView={{opacity:1,y:0}} viewport={{once:true}} style={{color:'#1a1a1a'}}>Our Services</SectionTitle>
              <SectionSubtitle initial={{opacity:0,y:30}} whileInView={{opacity:1,y:0}} viewport={{once:true}} style={{color:'#1a1a1a'}}>
                Fast, flexible and reliable delivery solutions across the UK
              </SectionSubtitle>

              <ServicesGrid>
                <ServiceCard initial={{opacity:0,y:30}} whileInView={{opacity:1,y:0}} viewport={{once:true}}>
                  <ServiceIcon
                    style={{
                      background: 'transparent',
                      padding: 0,
                      overflow: 'hidden',
                      width: '85%',
                      height: '140px',
                      margin: '0 auto 0.5rem auto'
                    }}
                  >
                    <img
                      src="/usl_multi.webp"
                      alt="Multi-drop delivery service"
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'contain',
                        display: 'block'
                      }}
                    />
                  </ServiceIcon>
                  <ServiceTitle>Multi-Drop Deliveries</ServiceTitle>
                  <ServiceDescription>Efficient multi-stop delivery solutions for businesses with multiple collection and delivery points across the UK.</ServiceDescription>
                
                  <Link
                    to="/get-a-quote?service=business"
                    className="services-card-quote"
                  >
                    Get a Free Quote
                  </Link>
                </ServiceCard>

                <ServiceCard initial={{opacity:0,y:30}} whileInView={{opacity:1,y:0}} viewport={{once:true}} transition={{delay:0.1}}>
                  <ServiceIcon
                    style={{
                      background: 'transparent',
                      padding: 0,
                      overflow: 'hidden',
                      width: '85%',
                      height: '140px',
                      margin: '0 auto 0.5rem auto'
                    }}
                  >
                    <img
                      src="/Clock.webp"
                      alt="Overnight delivery service"
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'contain',
                        display: 'block'
                      }}
                    />
                  </ServiceIcon>
                  <ServiceTitle>Overnight Deliveries</ServiceTitle>
                  <ServiceDescription>Collect today, deliver tomorrow. Reliable overnight delivery with flexible collections and nationwide coverage.</ServiceDescription>
                
                  <Link
                    to="/get-a-quote?service=business"
                    className="services-card-quote"
                  >
                    Get a Free Quote
                  </Link>
                </ServiceCard>

                <ServiceCard initial={{opacity:0,y:30}} whileInView={{opacity:1,y:0}} viewport={{once:true}} transition={{delay:0.2}}>
                  <ServiceIcon
                    style={{
                      background: 'transparent',
                      padding: 0,
                      overflow: 'hidden',
                      width: '85%',
                      height: '140px',
                      margin: '0 auto 0.5rem auto'
                    }}
                  >
                    <img
                      src="/bbc.webp"
                      alt="Business bulk collections service"
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'contain',
                        display: 'block'
                      }}
                    />
                  </ServiceIcon>
                  <ServiceTitle>Business Bulk Collections</ServiceTitle>
                  <ServiceDescription>Daily or weekly scheduled pickups for e-commerce, retail & offices. Fixed routes, lower rates.</ServiceDescription>
                
                  <Link
                    to="/get-a-quote?service=business"
                    className="services-card-quote"
                  >
                    Get a Free Quote
                  </Link>
                </ServiceCard>

                <ServiceCard initial={{opacity:0,y:30}} whileInView={{opacity:1,y:0}} viewport={{once:true}} transition={{delay:0.3}}>
                  <ServiceIcon
                    style={{
                      background: 'transparent',
                      padding: 0,
                      overflow: 'hidden',
                      width: '85%',
                      height: '140px',
                      margin: '0 auto 0.5rem auto'
                    }}
                  >
                    <img
                      src="/same_day.webp"
                      alt="Same day delivery service"
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'contain',
                        display: 'block'
                      }}
                    />
                  </ServiceIcon>
                  <ServiceTitle>Same Day Delivery</ServiceTitle>
                  <ServiceDescription>Urgent? We've got you covered. Same-day courier service for time-critical shipments.</ServiceDescription>
                
                  <Link
                    to="/get-a-quote?service=business"
                    className="services-card-quote"
                  >
                    Get a Free Quote
                  </Link>
                </ServiceCard>

                {/* HOME & FLAT MOVES */}
                <ServiceCard
                  initial={{opacity:0,y:30}}
                  whileInView={{opacity:1,y:0}}
                  viewport={{once:true}}
                  transition={{delay:0.4}}
                  style={{textDecoration:'none',color:'inherit'}}
                >
                  <ServiceIcon
                    style={{
                      background: 'transparent',
                      padding: 0,
                      overflow: 'hidden',
                      width: '85%',
                      height: '140px',
                      margin: '0 auto 0.5rem auto'
                    }}
                  >
                    <img
                      src="/sofa_new.webp"
                      alt="House and flat moving service"
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'contain',
                        display: 'block'
                      }}
                    />
                  </ServiceIcon>
                  <ServiceTitle>House &amp; Flat Moves</ServiceTitle>
                  <ServiceDescription>
                    Moving home doesn't have to be stressful.
                    From studio flats to family homes, we provide
                    reliable, flexible moving services to get your
                    belongings safely from door to door, anywhere
                    in the UK.
                  </ServiceDescription>
                
                  <Link
                    to="/get-a-quote?service=house"
                    className="services-card-quote"
                  >
                    Get a Free Quote
                  </Link>
                </ServiceCard>

                {/* FURNITURE MOVES */}
                <ServiceCard
                  initial={{opacity:0,y:30}}
                  whileInView={{opacity:1,y:0}}
                  viewport={{once:true}}
                  transition={{delay:0.5}}
                  style={{textDecoration:'none',color:'inherit'}}
                >
                  <ServiceIcon
                    style={{
                      background: 'transparent',
                      padding: 0,
                      overflow: 'hidden',
                      width: '85%',
                      height: '140px',
                      margin: '0 auto 0.5rem auto'
                    }}
                  >
                    <img
                      src="/sofa_move.webp"
                      alt="Furniture moving service"
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'contain',
                        display: 'block'
                      }}
                    />
                  </ServiceIcon>
                  <ServiceTitle>Furniture Moves</ServiceTitle>
                  <ServiceDescription>
                    Bought a new sofa, bed or wardrobe?
                    Whether it's a single item or multiple
                    pieces of furniture, we'll handle collection
                    and delivery with care, making furniture
                    transport simple and hassle-free.
                  </ServiceDescription>
                
                  <Link
                    to="/get-a-quote?service=large"
                    className="services-card-quote"
                  >
                    Get a Free Quote
                  </Link>
                </ServiceCard>
              </ServicesGrid>
            </Section>


      <section className="services-cta-banner">
        <div className="services-cta-inner">
          <div>
            <h2>Need Something Delivered or Moved?</h2>
            <p>
              Tell us what you need and we'll provide a free,
              no-obligation quote tailored to your requirements.
            </p>
          </div>

          <div className="services-cta-actions">
            <Link to="/get-a-quote" className="services-cta-primary">
              Get a Free Quote
            </Link>
            <Link to="/contact" className="services-cta-secondary">
              Contact Us
            </Link>
          </div>
        </div>
      </section>

      <div className="services-testimonials-white">
        <Testimonials />
      </div>

                  <div className="services-review-cta">
        <p>Ready to experience our service for yourself?</p>
        <Link to="/get-a-quote">Request Your Free Quote →</Link>
      </div>

      <Footer>
              <FooterContent className="responsive-footer">
                <FooterColumn>
                  <h4>Urgent Logistics</h4>
                  <p>Reliable courier, transport and removals services across the UK, including London and the South Coast. From business deliveries to house moves and furniture transport, Urgent Logistics offers flexible solutions to get your items moving safely and efficiently.</p>
                </FooterColumn>
                <FooterColumn>
                  <h4>Contact Info</h4>
                  <p style={{display:'flex',alignItems:'center',gap:'8px',margin:'0 0 12px'}}><Mail size={16}/> info@urgentservicelogistics.co.uk</p>
                  <p style={{display:'flex',alignItems:'center',gap:'8px',margin:'0 0 12px'}}><Phone size={16}/><a href="tel:+447436117842" style={{color:'inherit',textDecoration:'none',lineHeight:'inherit'}}>07436 117842</a></p>
                  <p style={{display:'flex',alignItems:'center',gap:'8px',margin:'0 0 12px'}}><MapPinned size={16}/> Hampshire</p>
                </FooterColumn>
                <FooterColumn>
                  <h4>Operating Hours</h4>
                  <p style={{margin:'0 0 8px', lineHeight:'1.6'}}><strong>Deliveries:</strong> 24 Hours, 7 Days</p>
                  <p style={{margin:'0 0 8px', lineHeight:'1.6'}}><strong>Phone Support:</strong></p>
                  <p style={{margin:'0 0 8px', lineHeight:'1.6'}}>Mon &ndash; Sat: 08:00 am &ndash; 20:00 pm</p>
                  <p style={{margin:'0 0 8px', lineHeight:'1.6'}}>Sun: 09:00 am &ndash; 21:00 pm</p>
                </FooterColumn>
              </FooterContent>
              <Copyright>
                © 2025 Urgent Logistics. All rights reserved. 
                Website by <a href="https://draftpoint.co.uk" target="_blank" rel="noopener noreferrer" style={{color:'#ff6b35',textDecoration:'none'}}>Draftpoint</a>
              </Copyright>
            </Footer>
    </main>
  );
}
